<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="invoices"
            :search="search"
            sort-by="calories"
            class="elevation-1"
            >
            <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Invoice</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-btn @click="listInvoices()" color="primary" dark class="mb-2">Seach</v-btn>
                    <v-spacer></v-spacer>        
               <template>
                    <v-row justify="center">
                        <v-dialog v-model="dialog" persistent max-width="650px">
                        <template v-slot:activator="{ on }" v-if="privileges">
                            <v-btn color="primary" dark v-on="on">New</v-btn>
                           
                        </template>
                        <v-card>
                            <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                           
                            <v-card-text>                            
                            <v-container>                              
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                </v-flex>   
                                <v-row>
                                    
                                    <v-col cols="12" sm="6" md="6">
                                        <template>
                                        <v-file-input 
                                            v-model="file"                                     
                                            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            placeholder="Select your file template"                                        
                                            label="File"
                                        ></v-file-input>
                                        </template>
                                     </v-col>
                                                                                   
                                </v-row>                            
                            </v-container>
                            <small>*indicates required field</small>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>                            
                                <v-btn
                                    :disabled="dialogLoading"
                                    :loading="dialogLoading"
                                    color="blue darken-1" text @click="save"
                                    >
                                    Save
                                </v-btn>
                            
                           
                           <v-dialog
                                v-model="dialogLoading"
                                hide-overlay
                                persistent
                                width="300"
                                >
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text>
                                    Saving, please be patient.
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                                </v-dialog>
            



                            </v-card-actions>
                        </v-card>
                        </v-dialog>
                    </v-row>
                </template>
            </v-toolbar>
        </template>
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.id">                                           
                            <td class="text-xs-right">{{item.eta_week}} </td>                            
                            <td class="text-xs-right">{{item.destination_port}} </td>
                            <td class="text-xs-right">{{item.invoice_no}} </td>                           
                            <td class="text-xs-right">{{item.container}} </td>
                            <td class="text-xs-right">{{item.cnt_urgent}} </td>                              
                            <td class="text-xs-right">{{item.transport_destination}} </td> 
                            <td class="text-xs-right">{{item.operator_name}} </td>
                            <td class="text-xs-right">{{item.box_no}} </td>                              
                            <td class="text-xs-right">{{item.box_plate}} </td> 
                            <td class="text-xs-right">{{item.economic_no}} </td>
                            <td class="text-xs-right">{{item.tractor_plate}} </td>                              
                            <td class="text-xs-right">{{item.seal_no}} </td>
                            <td class="text-xs-right">{{item.delivery_dt}} </td>
                            <td class="text-xs-right">{{item.final_destination}} </td>                            
                            <td class="text-xs-right">                                                        
                                <div v-if="!item.received">
                                    <span class="orange--text"> In transit</span>                                    
                                </div>
                                <div v-else>
                                <span class="blue--text">Done</span>
                                </div>                                
                            </td>

                            <td class="text-xs-right">{{moment(item.Create_dt).format('MM/DD/YYYY')}} </td>


                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
    </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
    import VueJsonToCsv from 'vue-json-to-csv'
   
    export default{
        components: {
              "vue-json-to-csv": VueJsonToCsv          
        },       
        data (){
            return {
                  moment:moment,                
                  invoices:[],                  
                  dialog: false,
                  dialogLoading: false,

                  templateName: "manzanillo_Invoice_Template",
                    templateCsv: [
                        
                       {ETA_WEEK: '',	DESTINATION_PORT:'',
                       INVOICE_NO:'',CONTAINER:'',CNT_URGENT:'',TRANSPORT_DESTINATION:'',
                       OPERATION_NAME:'',BOX_NO:'',BOX_PLATE:'',
                       TRACTOR_ECONOMIC_NO:'',TRACTOR_PLATE:'',SEAL_NO:'',
                       DELIVERY_TO_JUAREZ:'', FINAL_DESTINATION:''}

                    ],

                    headers: [
                       // { text: 'Actions', value: 'action', sortable: false },                       
                        { text: 'ETA Week', value: 'eta_week', sortable: false },
                        { text: 'Port', value: 'destination_port', sortable: false },
                        { text: 'Invoice', value: 'invoice_no', sortable: false },
                        { text: 'Container', value: 'container', sortable: false },                      
                        { text: 'CNT urgent', value: 'cnt_urgent', sortable: false },
                        { text: 'Transport ', value: 'transport_destination', sortable: false },
                        { text: 'Operator', value: 'operator_name', sortable: false },
                        { text: 'Box No', value: 'box_no', sortable: false },
                        { text: 'Box Plate', value: 'box_plate', sortable: false },
                        { text: 'Economic No', value: 'economic_no', sortable: false },
                        { text: 'Tractor Plate', value: 'tractor_plate', sortable: false },                        
                        { text: 'Seal No', value: 'seal_no', sortable: true },
                        { text: 'Delivery Date', value: 'delivery_dt', sortable: false },
                        { text: 'Destination', value: 'final_destination', sortable: false },                        
                        { text: 'Received', value: 'Received', sortable: true },
                        { text: 'Create DT', value: 'Create_dt', sortable: false }

                    ],
                    //moment: moment, // Set to whatever
                    privileges: false,
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                    file: null,
                  
                    id: '', 
                    invoiceNo: '', 
                    transportDestination: '', 
                    operatorName: '', 
                    boxNo: '', 
                    boxPlate: '', 
                    economicNo: '',
                    tractorPlate: '', 
                    sealNo: '', 
                    delivery_dt: '',                   
                    creator : '', 
                    create_dt: '', 
                  
                   
                    valida:0,
                    validaMensaje:[]   
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Invoice' : 'Edit Invoice'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();
            this.listInvoices();
            this.havePriviges();     
        },

         methods: { 
              exitApp(){
          this.$store.dispatch("exit");
        },
              havePriviges() {
                this.$store.state.user.rol === "yms_customs" ? this.privileges =false : this.privileges =true
            } ,           
            listInvoices(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                if (!me.search){
                    url ='api/Invoices/List';
                }
                else{
                    url ='api/Invoices/ListFilter/' + me.search;
                }
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.invoices = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            
            initialize () {                            
            },
            
            editItem (item) {
                                               
                this.id= item.id;  
                //this.invoiceNo= item.invoiceNo; 
                //this.transportDestination= item.transportDestination; 
                //this.operatorName= item.operatorName; 
                //this.boxNo= item.boxNo; 
                //this.boxPlate= item.boxPlate; 
                //this.economicNo= item.economicNo; 
                //this.tractorPlate= item.tractorPlate; 
                //this.sealNo= item.sealNo;                 
                //this.delivery_dt= moment(item.delivery_dt).format('YYYY-MM-DD');                
               
                this.creator= 'RAFBEL';                

                this.editedIndex=1;
                this.dialog = true
            },

            deleteItem (item) {
                const index = this.desserts.indexOf(item)
                confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.id= ""; 
                this.invoiceNo= "";
                this.transportDestination= "";
                this.operatorName= ""; 
                this.boxNo= ""; 
                this.boxPlate= ""; 
                this.economicNo= "";
                this.tractorPlate= "";
                this.sealNo= "";
                this.delivery_dt= "";              
                this.creator=  "";    

                this.editedIndex=-1;

                this.file= null;

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
            save () {               
                if (this.validar() > 0)  {                                      
                     return;   
                }                 
                
                if (this.editedIndex > -1) {                   
                   //Code for Edit Mode
                   this.dialogLoading = true;
                   let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/Invoices/Update',{                                                   
                        'invoiceID':me.id,                                         
                        'transportDestination': me.transportDestination,
                        'operatorName': me.operatorName, 
                        'boxNo': me.boxNo,
                        'boxPlate': me.boxPlate,
                        'economicNo': me.economicNo,
                        'tractorPlate': me.tractorPlate,
                        'sealNo': me.sealNo,
                        'delivery_dt': me.delivery_dt, 
                        'updater': me.creator      
                    },configuration).then(function(response){
                        me.close();
                        me.listInvoices();
                        me.clean();
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);                   

                } else {                    
                    //Code for Save                   
                   if (this.validar()){
                       return;
                   }

                    let me=this;    
                    //let header={"Authorization": "Bearer " + this.$store.state.token};
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };

                    let configuration = {headers : header };
                    this.dialogLoading = true; 

                    let formData = new FormData();  
                    formData.append("file", me.file);  
                     

                    axios.post('api/Invoices/Create',formData,configuration).then(function(response){
                        //console.log('Save');
                        me.close();
                        me.listInvoices();
                        me.clean();
                        console.log(response.data.msg);
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,
                        this.validaMensaje.push('Done.')
                    );  
                   
                }               
            },
           
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.file){
                     this.validaMensaje.push('Input the File');
                 }   
                // if (!this.delivery_dt){
                 //    this.validaMensaje.push('Input the Delivery Date');
                // }
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>